import * as React from "react";
import {Container} from "reactstrap";
import styled from "styled-components";

import Layout from "../Layout";
import RockForm from "../apps/rock-calculator/RockForm";
import AppHeader from "../AppHeader";
import AppLogo from "../AppLogo";
import AppUpdateDate from "../AppUpdateDate";
import AppVersion from "../AppVersion";
import AppCompatibility from "../AppCompatibility";
import starCitizen from "../../StarCitizen";
import app from "../apps/rock-calculator/app"
import AdsharesBanner from "../AdsharesBanner"

const AppMetaData = styled.span`

    @media (min-width: 768px) {
        float:right;
    }
`;

const RockCalculator = () => (
    <Layout>
        <main>
            <Container>
                <AppHeader>
                    <AppLogo src="/images/rock-calculator-icon.svg" />
                    {app.name}
                    <AppVersion version={app.version} />
                    <AppMetaData>
                        <AppUpdateDate date={app.updateDate} />
                        <AppCompatibility starCitizenVersion={starCitizen.currentVersion} />
                    </AppMetaData>
                </AppHeader>
                <RockForm />
                <AdsharesBanner />
            </ Container>
        </main>
        <div className="instructions">
            <Container>
                <h2>{app.name} instructions</h2>
                <p>
                    After scanning a rock, enter the mass in the first field and then
                    start adding each of the rock's elements by clicking the
                    add button.
                </p>
                <p>
                    Select the element from the drop down and then enter the
                    percentage of that element into the percent field for that element.
                    As you change any of the values the total value of the rock will update at the bottom
                    to reflect how much you can expect to be paid if you extract all of the
                    elements in the rock.
                </p>
                <p>
                    The inert material content of the rock is automatically calculated for you
                    based on the composition of the rock specified. You can start again by clicking clear
                    and resetting the form.
                </p>
                <p>Element base values are currently taken from <a href="https://sc-trade.tools/mining" title="SC Trade Tools">SC Trade Tools</a>.</p>
            </ Container>
        </div>
    </Layout>
);

export default RockCalculator;